|
<aside #asideElem class="static-menu" id="menu-lat-container" style="overflow: hidden" (mouseenter)="mouseEnter()">
  <div class="menu-list">
    <ion-item lines="none" color="light-black" class="menu-lat-header-logo"
      style="display: block !important; padding-left: 23px">
      <img style="width: 15%" class="logo-emblema" slot="start" src="/assets/imgs/logo/csi/Emblema_Color.png"
        draggable="false" />
      <ion-label class="center-left-box ion-no-margin">
        <img style="width: 60%; display: block !important" class="logo-wordmark" slot="start"
          src="/assets/imgs/logo/csi/CSI_Logotipo_Color.png" draggable="false" [hidden]="false" />
      </ion-label>
      <ion-icon class="hamburguer-icon" name="menu" slot="end" (click)="toggleStaticMenu(true)"></ion-icon>
    </ion-item>
    <div #scrollbarContainer class="scrollbar-container">
      <ion-item class="menu-item quantum-logo" lines="none">
        <img class="quantum-logo" slot="start" src="/assets/imgs/logo/emblema/Quantum-Emblema-blue.png"
          draggable="false" />
        <ion-label class="vertical-center-box">
          <img style="width: 70%; display: block !important" class="" slot="start"
            src="/assets/imgs/logo/wordmark/Quantum-Wordmark-Blue.png" draggable="false" [hidden]="false" />
        </ion-label>
        <i slot="end" class="arrow arrow-down"></i>
      </ion-item>

      <div class="submenu-list" #submenuElem>
        @if (showHome) {
        <ion-item class="menu-item home-item" [color]="activeMenuItem === 'home-item' ? 'tech-blue' : 'light-black'"
          lines="none" [ngClass]="activeMenuItem === 'home-item' ? 'active' : null" (click)="goToHome()">
          <ion-icon slot="start" name="home"></ion-icon>
          <p>{{ "Menu._Home" | translate }}</p>
        </ion-item>
        }

        <!-- Dashboards - INICIO -->
        @if (dashboardFinancieroActive) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-item' &&currentDashboard === 'financiero'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-item' &&currentDashboard === 'financiero'? 'active': null"
          (click)="goToDashboardFinanciero()">
          <ion-icon slot="start" name="cash-outline"></ion-icon>
          <p>{{ "Menu.Dashboard._Financiero" | translate }}</p>
        </ion-item>
        }

        @if (dashboardOperativoActive) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-item' &&currentDashboard === 'operativo'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-item' &&currentDashboard === 'operativo'? 'active': null"
          (click)="goToDashboardOperativo()">
          <ion-icon slot="start" name="aperture-outline"></ion-icon>
          <p>{{ "Menu.Dashboard._Operativo" | translate }}</p>
        </ion-item>
        }

        @if (dashboardAMDF) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-item' && currentDashboard === 'amdf'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-item' && currentDashboard === 'amdf'? 'active': null"
          (click)="goToDashboardAMDF()">
          <ion-icon slot="start" name="cash-outline"></ion-icon>
          <p>{{ "Menu.Dashboard._AMDF" | translate }}</p>
        </ion-item>
        }

        @if (dashboardMazda) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-item' &&currentDashboard === 'mazda'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-item' &&currentDashboard === 'mazda'? 'active': null"
          (click)="goToDashboardMazda()">
          <ion-icon slot="start" name="cash-outline"></ion-icon>
          <p>{{ "Menu.Dashboard._Mazda" | translate }}</p>
        </ion-item>
        }

        @if (dashboardBMW) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-item' && currentDashboard === 'bmw'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-item' && currentDashboard === 'bmw'? 'active': null"
          (click)="goToDashboardBMW()">
          <ion-icon slot="start" name="cash-outline"></ion-icon>
          <p>{{ "Menu.Dashboard._BMW" | translate }}</p>
        </ion-item>
        }
        <!-- Dashboards - FIN -->

        <!-- BSC Dashboards - INICIO -->
        @if (dashboardBSC_CPVActive) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CPVActive &&currentDashboardBSC === 'cpv'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CPVActive &&currentDashboardBSC === 'cpv'? 'active': null"
          (click)="goToDashboardBSCCPV()">
          <!-- <ion-icon name="stats-chart" slot="start"></ion-icon> -->
          <ion-icon slot="start" name="file-tray-full-outline"></ion-icon>
          <p>{{ "Menu.BSC._CPV" | translate }}</p>
        </ion-item>
        }

        @if (dashboardBSC_CSIActive) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CSIActive &&currentDashboardBSC === 'csi'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CSIActive &&currentDashboardBSC === 'csi'? 'active': null"
          (click)="goToDashboardBSCCSI()">
          <!-- <ion-icon name="stats-chart" slot="start"></ion-icon> -->
          <ion-icon slot="start" name="file-tray-full-outline"></ion-icon>
          <p>{{ "Menu.BSC._CSI" | translate }}</p>
        </ion-item>
        }

        @if (dashboardBSC_CSIDActive) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CSIDActive &&currentDashboardBSC === 'csid'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CSIDActive &&currentDashboardBSC === 'csid'? 'active': null"
          (click)="goToDashboardBSCCSID()">
          <!-- <ion-icon name="stats-chart" slot="start"></ion-icon> -->
          <ion-icon slot="start" name="file-tray-full-outline"></ion-icon>
          <p>{{ "Menu.BSC._CSID" | translate }}</p>
        </ion-item>
        }

        @if (dashboardBSC_CSIXActive) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CSIXActive &&currentDashboardBSC === 'csix'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_CSIXActive &&currentDashboardBSC === 'csix'? 'active': null"
          (click)="goToDashboardBSCCSIX()">
          <!-- <ion-icon name="stats-chart" slot="start"></ion-icon> -->
          <ion-icon slot="start" name="file-tray-full-outline"></ion-icon>
          <p>{{ "Menu.BSC._CSIX" | translate }}</p>
        </ion-item>
        }

        @if (dashboardBSC_SunusActive) {
        <ion-item class="menu-item" lines="none"
          [color]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_SunusActive &&currentDashboardBSC === 'sunus'? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'dashboard-bsc-item' &&dashboardBSC_SunusActive &&currentDashboardBSC === 'sunus'? 'active': null"
          (click)="goToDashboardBSCSunus()">
          <!-- <ion-icon name="stats-chart" slot="start"></ion-icon> -->
          <ion-icon slot="start" name="file-tray-full-outline"></ion-icon>
          <p>{{ "Menu.BSC._SUNUS" | translate }}</p>
        </ion-item>
        }
        <!-- BSC Dashboards - END -->

        @if (showInvestorRelations) {
        <ion-item class="menu-item investor-relations-item"
          [color]="activeMenuItem === 'investor-relations-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'investor-relations-item' ? 'active' : null"
          (click)="goToInvestorRelationsPage()">
          <ion-icon slot="start" name="folder-outline"></ion-icon>
          <p>{{ "Menu._Investor" | translate }}</p>
        </ion-item>
        }

        @if (showTrackingMap) {
        <ion-item class="menu-item tracking-map-item"
          [color]="activeMenuItem === 'tracking-map-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'tracking-map-item' ? 'active' : null" (click)="goToTrackingMap()">
          <ion-icon slot="start" name="location"></ion-icon>
          <p>{{ "Menu._Rastreo" | translate }}</p>
        </ion-item>
        }

        @if (showTravelList) {
        <ion-item class="menu-item travel-list-item"
          [color]="activeMenuItem === 'travel-list-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'travel-list-item' ? 'active' : null" (click)="goToTravelList()">
          <ion-icon slot="start" name="list"></ion-icon>
          <p>{{ "Menu._Viajes" | translate }}</p>
        </ion-item>
        }

        <!-- @if(showTravelList) {
        <ion-item class="menu-item vessel-travel-list-item"
          [color]="activeMenuItem === 'vessel-travel-list-item' ? 'tech-blue' : 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'vessel-travel-list-item' ? 'active' : null" (click)="goToVesselTravelList()">
          <ion-icon slot="start" name="list"></ion-icon>
          <p>{{ 'Menu._Viajes_Buque' | translate }}</p>
        </ion-item> 
        } -->

        @if (showScore) {
        <ion-item class="menu-item ratings-item"
          [color]="activeMenuItem === 'ratings-item' ? 'tech-blue' : 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'ratings-item' ? 'active' : null" (click)="goToScore()">
          <ion-icon slot="start" src="/assets/imgs/icons/star.svg"></ion-icon>
          <p>{{ "Menu._Ratings" | translate }}</p>
        </ion-item>
        }

        @if (showExchange) {
        <ion-item class="menu-item exchange-item"
          [color]="activeMenuItem === 'exchange-item' ? 'tech-blue' : 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'exchange-item' ? 'active' : null" (click)="goToExchange()">
          <ion-icon name="repeat-sharp" slot="start"></ion-icon>
          <p>{{ "Menu._Intercambios" | translate }}</p>
        </ion-item>
        }

        @if (showShipmentRequest) {
        <ion-item class="menu-item shipment-request-item"
          [color]="activeMenuItem === 'shipment-request-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'shipment-request-item' ? 'active' : null" (click)="goToShipmentRequest()">
          <ion-icon name="car" slot="start"></ion-icon>
          <p>{{ "Menu._Embarque" | translate }}</p>
        </ion-item>
        }

        @if (showReport) {
        <ion-item class="menu-item report-list-item"
          [color]="activeMenuItem === 'report-list-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'report-list-item' ? 'active' : null" (click)="goToReports()">
          <ion-icon slot="start" name="document"></ion-icon>
          <p>{{ "Menu._Reportes" | translate }}</p>
        </ion-item>
        }

        <!--cambio its-->
        @if (showConsultBySiteMexico) {
        <ion-item class="menu-item consulta-cd-item"
          [color]="activeMenuItem === 'consulta-cd-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'consulta-cd-item' ? 'active' : null" (click)="goToConsultBySiteMexico()">
          <ion-icon slot="start" name="business-outline"></ion-icon>
          <p>{{ "Menu._Consulta_CD" | translate }}</p>
        </ion-item>
        }

        @if (showMultipleVinConsult) {
        <ion-item class="menu-item consulta-vin-item"
          [color]="activeMenuItem === 'consulta-vin-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'consulta-vin-item' ? 'active' : null" (click)="goToMultipleVinConsult()">
          <ion-icon slot="start" name="search"></ion-icon>
          <p>{{ "Menu._Consulta_VIN" | translate }}</p>
        </ion-item>
        }

        @if (showAssetsManager) {
        <ion-item class="menu-item assets-manager-item"
          [color]="activeMenuItem === 'assets-manager-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'assets-manager-item' ? 'active' : null" (click)="goToAssetsManagerPage()">
          <ion-icon slot="start" name="layers-outline"></ion-icon>
          <p>{{ "Menu._Assets" | translate }}</p>
        </ion-item>
        }

        @if (showMatrizEstatusEquipo) {
        <ion-item class="menu-item matriz-estatus-item"
          [color]="activeMenuItem === 'matriz-estatus-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'matriz-estatus-item' ? 'active' : null" (click)="goToMatrizEstatusEquipo()">
          <ion-icon slot="start" name="bus"></ion-icon>
          <p>{{ "Menu._Matriz" | translate }}</p>
        </ion-item>
        }

        @if (showProgramacionCarga) {
        <ion-item class="menu-item programacion-carga-item"
          [color]="activeMenuItem === 'programacion-carga-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'programacion-carga-item' ? 'active' : null" (click)="goToProgramacionCarga()">
          <ion-icon slot="start" name="compass"></ion-icon>
          <p>{{ "Menu._Posicionamiento" | translate }}</p>
        </ion-item>
        }

        @if (showAlertasPage) {
        <ion-item class="menu-item alarmas-item"
          [color]="activeMenuItem === 'alarmas-item' ? 'tech-blue' : 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'alarmas-item' ? 'active' : null" (click)="goToAlertasPage()">
          <ion-icon slot="start" name="alert"></ion-icon>
          <p>{{ "Menu._Alertas" | translate }}</p>
        </ion-item>
        }

        @if (showConsultaDeTractor) {
        <ion-item class="menu-item consulta-tractor-item"
          [color]="activeMenuItem === 'consulta-tractor-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'consulta-tractor-item' ? 'active' : null" (click)="goToConsultaDeTractor()">
          <ion-icon slot="start" name="search"></ion-icon>
          <p>{{ "Menu._Tractor" | translate }}</p>
        </ion-item>
        }

        <!-- @if (showRateTrip) {
        <ion-item class="menu-item rate-trip-item"
          [color]="activeMenuItem === 'rate-trip-item' ? 'tech-blue' : 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'rate-trip-item' ? 'active' : null" (click)="goToRateTrip()">
          <ion-icon slot="start" name="star"></ion-icon>
          <p>{{ "Titulo._Calificar_Viaje" | translate }}</p>
        </ion-item>
        } -->

        @if (showPermissions) {
        <ion-item class="menu-item permisos-item"
          [color]="activeMenuItem === 'permisos-item' ? 'tech-blue' : 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'permisos-item' ? 'active' : null" (click)="goToUserPermissions()">
          <ion-icon slot="start" name="people-circle"></ion-icon>
          <p>{{ "Menu._Permisos" | translate }}</p>
        </ion-item>
        }

        <!-- Quantum CIVAR Item -->
        @if (loaddedQuantumCivarMenu) {
        @for (quantumCivarItem of quantumCivarMenu[0].OpcionMenu; track quantumCivarItem; let idx = $index) {
        <ion-item class="menu-item civar-item" lines="none"
          [color]="activeMenuItem === 'civar-item' &&currentCivarQuantumItem === quantumCivarItem.Id_Cnsc_Menu? 'tech-blue': 'light-black'"
          [ngClass]="activeMenuItem === 'civar-item' &&currentCivarQuantumItem === quantumCivarItem.Id_Cnsc_Menu? 'active': null"
          (click)="openPage(quantumCivarItem)">
          <ion-icon slot="start" [name]="getIconNameCivarMenu(quantumCivarItem.Cve_Desc_Menu)"></ion-icon>
          <p>{{ quantumCivarItem.Cve_Desc_Menu | titlecase }}</p>
        </ion-item>
        }
        }
        <!-- Quantum CIVAR Item -->

        @if (showConfig) {
        <ion-item class="menu-item configuracion-item"
          [color]="activeMenuItem === 'configuracion-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'configuracion-item' ? 'active' : null" (click)="goToConfig()">
          <ion-icon slot="start" name="settings"></ion-icon>
          <p>{{ "Menu._Configuración" | translate }}</p>
        </ion-item>
        }

        @if (showAdminPanel) {
        <ion-item class="menu-item admin-panel-item"
          [color]="activeMenuItem === 'admin-panel-item'? 'tech-blue': 'light-black'" lines="none"
          [ngClass]="activeMenuItem === 'admin-panel-item' ? 'active' : null" (click)="goToAdminPanel()">
          <ion-icon slot="start"
            [src]="activeMenuItem === 'admin-panel-item'? '/assets/imgs/icons/admin-panel.svg': '/assets/imgs/icons/admin-panel-w.svg'">
          </ion-icon>
          <p>{{ "Menu._Panel_Administrador" | translate }}</p>
        </ion-item>
        }

        @if (showMoreMenu) {
        <ion-item class="menu-item show-more-item" color="light-black" lines="none" (click)="toggleShowMoreSubmenu()">
          <ion-icon slot="start" name="ellipsis-vertical-outline"></ion-icon>
          @if (showMoreMenuDetails) {
          <p>{{ "Menu._Show_Less" | translate }}</p>
          } @else {
          <p>{{ "Menu._Show_More" | translate }}</p>
          }
          <i slot="end" class="arrow" [ngClass]="showMoreMenuDetails ? 'arrow-down' : 'arrow-right'"></i>
        </ion-item>
        }

        <div class="more-submenu" #moreMenuSubmenuElem>
          <div>
            <ul>
              @if (showInvestorRelations_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'investor-relations-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'investor-relations-item'? 'active': null"
                        (click)="goToInvestorRelationsPage()">
                        <ion-icon slot="start" name="folder-outline"></ion-icon>
                        <p>{{ "Menu._Investor" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showTrackingMap_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'tracking-map-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'tracking-map-item'? 'active': null" (click)="goToTrackingMap()">
                        <ion-icon slot="start" name="location"></ion-icon>
                        <p>{{ "Menu._Rastreo" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showTravelList_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'travel-list-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'travel-list-item'? 'active': null" (click)="goToTravelList()">
                        <ion-icon slot="start" name="list"></ion-icon>
                        <p>{{ "Menu._Viajes" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showScore_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'ratings-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'ratings-item' ? 'active' : null" (click)="goToScore()">
                        <ion-icon slot="start" src="/assets/imgs/icons/star.svg"></ion-icon>
                        <p>{{ "Menu._Ratings" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showExchange_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'exchange-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'exchange-item' ? 'active' : null" (click)="goToExchange()">
                        <ion-icon name="repeat-sharp" slot="start"></ion-icon>
                        <p>{{ "Menu._Intercambios" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showShipmentRequest_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'shipment-request-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'shipment-request-item'? 'active': null"
                        (click)="goToShipmentRequest()">
                        <ion-icon name="car" slot="start"></ion-icon>
                        <p>{{ "Menu._Embarque" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showReport_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'report-list-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'report-list-item'? 'active': null" (click)="goToReports()">
                        <ion-icon slot="start" name="document"></ion-icon>
                        <p>{{ "Menu._Reportes" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showConsultBySiteMexico_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'consulta-cd-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'consulta-cd-item'? 'active': null"
                        (click)="goToConsultBySiteMexico()">
                        <ion-icon slot="start" name="business-outline"></ion-icon>
                        <p>{{ "Menu._Consulta_CD" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showMultipleVinConsult_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'consulta-vin-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'consulta-vin-item'? 'active': null"
                        (click)="goToMultipleVinConsult()">
                        <ion-icon slot="start" name="search"></ion-icon>
                        <p>{{ "Menu._Consulta_VIN" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showAssetsManager_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'assets-manager-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'assets-manager-item'? 'active': null"
                        (click)="goToAssetsManagerPage()">
                        <ion-icon slot="start" name="bag-outline"></ion-icon>
                        <p>{{ "Menu._Assets" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showMatrizEstatusEquipo_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'matriz-estatus-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'matriz-estatus-item'? 'active': null"
                        (click)="goToMatrizEstatusEquipo()">
                        <ion-icon slot="start" name="bus"></ion-icon>
                        <p>{{ "Menu._Matriz" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showProgramacionCarga_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'programacion-carga-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'programacion-carga-item'? 'active': null"
                        (click)="goToProgramacionCarga()">
                        <ion-icon slot="start" name="compass"></ion-icon>
                        <p>{{ "Menu._Posicionamiento" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showAlertasPage_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'alarmas-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'alarmas-item' ? 'active' : null" (click)="goToAlertasPage()">
                        <ion-icon slot="start" name="alert"></ion-icon>
                        <p>{{ "Menu._Alertas" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              @if (showConsultaDeTractor_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'consulta-tractor-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'consulta-tractor-item'? 'active': null"
                        (click)="goToConsultaDeTractor()">
                        <ion-icon slot="start" name="search"></ion-icon>
                        <p>{{ "Menu._Tractor" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
              <!-- @if (showRateTrip_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'rate-trip-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'rate-trip-item'? 'active': null" (click)="goToRateTrip()">
                        <ion-icon slot="start" name="star"></ion-icon>
                        <p>{{ "Titulo._Calificar_Viaje" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              } -->
              @if (showPermissions_Collapsible) {
              <li class="ion-color-bg-light-black">
                <ion-grid class="bg-grid ion-no-padding">
                  <ion-row>
                    <ion-col size="12" class="ion-no-padding ion-color-bg-light-black">
                      <ion-item class="menu-item" lines="none"
                        [color]="activeMenuItem === 'permisos-item-item'? 'tech-blue': 'light-black'"
                        [ngClass]="activeMenuItem === 'permisos-item-item'? 'active': null"
                        (click)="goToUserPermissions()">
                        <ion-icon slot="start" name="people-circle"></ion-icon>
                        <p>{{ "Menu._Permisos" | translate }}</p>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </li>
              }
            </ul>
          </div>
        </div>
        <!--fin cambio its-->
      </div>

      <!-- Sub Menu de Quantum Drive -->
      @if (showDrive) {
      <ion-item class="menu-item quantum-logo" lines="none" (click)="goToWebFrame()">
        <img class="quantum-logo" slot="start"
          src="/assets/imgs/logo/wordmark/Quantum-Drive/Emblema/Quantum-Drive-Emblema-white.png" draggable="false" />
        <!-- <ion-label class="vertical-center-box">
          <img style="width: 70%;" class="" slot="start" src="/assets/imgs/logo/wordmark/Quantum-Drive/logo.png" draggable="false" />
        </ion-label> -->
        <p class="lb-logo-wordmark">Drive</p>
        <!-- <i slot="end" class="arrow" [ngClass]="showQuantumMenu ? 'arrow-down' : 'arrow-right'"></i> -->
      </ion-item>
      }

      <!-- Sub Menu de Quantum Fleet -->
      @if (showFleet) {
      <ion-item class="menu-item quantum-logo" lines="none" (click)="goToWebFrame()">
        <img class="quantum-logo" slot="start"
          src="/assets/imgs/logo/wordmark/Quantum-Fleet/Emblema/Quantum-Fleet-Emblema-white.png" draggable="false"
          draggable="false" />
        <!--         <ion-label class="vertical-center-box">
          <img style="width: 70%;" class="" slot="start" src="/assets/imgs/logo/wordmark/Quantum-Fleet/logo.png" draggable="false" />
        </ion-label> -->
        <p class="lb-logo-wordmark">Fleet</p>
        <!-- <i slot="end" class="arrow" [ngClass]="showQuantumMenu ? 'arrow-down' : 'arrow-right'"></i> -->
      </ion-item>
      }

      <!-- Sub Menu de Quantum Ontrack -->
      @if (showOntrack) {
      <ion-item class="menu-item quantum-logo" lines="none" (click)="toggleAppsMenu()">
        <img class="quantum-logo" slot="start"
          src="/assets/imgs/logo/wordmark/Quantum-Ontrack/Emblema/Quantum-Ontrack-Emblema-white.png"
          draggable="false" />
        <!-- <ion-label class="vertical-center-box">
          <img style="width: 70%;" class="" slot="start" src="/assets/imgs/logo/wordmark/Quantum-Ontrack/logo.png" draggable="false" />
        </ion-label> -->
        <p class="lb-logo-wordmark">Ontrack</p>
        <i slot="end" class="arrow" [ngClass]="showOntrackMenu ? 'arrow-down' : 'arrow-right'"></i>
      </ion-item>
      }

      <div class="submenu-app-list" #submenuOntrackElem>
        @if (showOntrack && showHome) {
        <ion-item class="menu-item home-item" [color]="activeMenuItem === 'home-item' ? 'tech-blue' : 'light-black'"
          lines="none" [ngClass]="activeMenuItem === 'home-item' ? 'active' : null" (click)="goToiFramePage()">
          <ion-icon slot="start" name="home"></ion-icon>
          <p>{{ "Menu._Home" | translate }}</p>
        </ion-item>
        }
      </div>

      <!-- Sub Menu de Quantum Yard -->
      @if (showYard) {
      <ion-item class="menu-item quantum-logo" lines="none" (click)="goToWebFrame()">
        <img class="quantum-logo" slot="start"
          src="/assets/imgs/logo/wordmark/Quantum-Yard/Emblema/Quantum-Yard-Emblema-white.png" draggable="false" />
        <!-- <ion-label class="vertical-center-box">
          <img style="width: 70%;" class="" slot="start" src="/assets/imgs/logo/wordmark/Quantum-Yard/logo.png" draggable="false" />
        </ion-label> -->
        <p class="lb-logo-wordmark">Yard</p>
        <!-- <i slot="end" class="arrow" [ngClass]="showQuantumMenu ? 'arrow-down' : 'arrow-right'"></i> -->
      </ion-item>
      }

      @for (civarItem of civarMenu; track civarItem; let idx = $index) {
      <ion-item class="menu-item" lines="none" (click)="toggleMenu(true, idx)">
        <ion-icon slot="start" [name]="getIconNameCivarMenu(civarItem.Cve_Desc_Menu)"></ion-icon>
        <p>{{ civarItem.Cve_Desc_Menu }}</p>
        <i slot="end" class="arrow" [ngClass]="showCivarMenu[idx] ? 'arrow-down' : 'arrow-right'"></i>
      </ion-item>
      <div class="civar-menu" #civarElem>
        <my-menu [items]="civarItem.OpcionMenu || []" [level]="1" (onSubmenuOpen)="resizeContainer($event, idx)">
        </my-menu>
      </div>
      }

      <ion-item class="menu-item" lines="none" (click)="logout()">
        <ion-icon slot="start" name="log-out-outline"></ion-icon>
        <p>{{ "Menu._Log_Out" | translate }}</p>
      </ion-item>
      <ion-item color="light-black" lines="none" style="height: 70px !important"></ion-item>
    </div>
  </div>
</aside>